import type { IconProps } from '../types/IconProps.ts';
export const ShoppingCart: IconProps = {
    name: 'ShoppingCart',
    children: [
        `<path d="M5 7h14.5a2 2 0 0 1 1.96 2.43l-1.11 5A2 2 0 0 1 18.4 16H8.6a2 2 0 0 1-1.95-1.57zm0 0L4 2M2 2h2" />`,
        `<circle cx="9" cy="21" r="1" />`,
        `<circle cx="18" cy="21" r="1" />`,
    ]
};